package feature.businessType.viewModel

import feature.app.AppViewModel
import feature.business.handler.BusinessHandler
import feature.businessType.handler.BusinessTypeHandler
import feature.businessType.model.BusinessType
import feature.businessType.network.BusinessTypeNetwork
import feature.businessType.network.BusinessTypeRequest
import feature.businessType.repository.BusinessTypeRepository
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.Job
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.launch

class BusinessTypeViewModel(private val repository: BusinessTypeRepository = BusinessTypeHandler.shared().repository) :
    AppViewModel() {
    val allBusinessType: StateFlow<List<BusinessType>>
        get() = repository.allBusinessTypeLiveData

    fun retrieve(completion: (() -> Unit) = {}) {
        val business = BusinessHandler.shared().repository.business
        val request = BusinessTypeRequest(business.value.Id)
        BusinessTypeNetwork().retrieve(request) {
            if (!it?.payload.isNullOrEmpty()) {
                CoroutineScope(Job() + Dispatchers.Default).launch {
                    repository.allBusinessTypeLiveData.emit(it!!.payload)
                }
            }
        }
    }
}